import { render, staticRenderFns } from "./keizoku.vue?vue&type=template&id=04f31d0a"
import script from "./keizoku.vue?vue&type=script&lang=js"
export * from "./keizoku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports